import { type ReactFlowState, useStore } from '@xyflow/react';

const getTransformSelector = (state: ReactFlowState) => state.transform;

export function useReactFlowTransformState() {
  const [, , reactFlowZoomLevel] = useStore(getTransformSelector);
  return { reactFlowZoomLevel };
}
